import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface LoginRequest {
  id: number;
  username: string;
  password: string;
  expiredAt: string;
  hash: string;
}

export interface TwoFactorRequest {
  email: string;
  code: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiBaseUrl + '/api/auth';

  constructor(private http: HttpClient) { }

  login(username: string, password: string): Observable<any> {
    const request: LoginRequest = {
      id: 0,
      username,
      password,
      expiredAt: new Date().toISOString(),
      hash: 'string'
    };

    return this.http.post(`${this.apiUrl}/login`, request);
  }

  verifyTwoFactor(email: string, code: string): Observable<any> {
    const request: TwoFactorRequest = {
      email,
      code
    };

    return this.http.post(`${this.apiUrl}/2fa/verify`, request);
  }

  getToken(): string | null {
    return sessionStorage.getItem('token');
  }

  getTokenPayload(): any | null {
    const token = this.getToken();
    return token ? this.parseJwt(token) : null;
  }

  getRoleId(): number | null {
    const payload = this.getTokenPayload();
    if (!payload) {
      return null;
    }

    const possibleClaims = [
      payload.roleId,
      payload.RoleId,
      payload.role,
      payload.Role,
      payload.roles,
      payload.Roles,
      payload.role_id,
      payload.roleID
    ];

    for (const claim of possibleClaims) {
      if (typeof claim === 'number') {
        return claim;
      }
      if (typeof claim === 'string' && claim.trim().length > 0 && !Number.isNaN(Number(claim))) {
        return Number(claim);
      }
      if (Array.isArray(claim) && claim.length > 0) {
        const first = claim[0];
        if (typeof first === 'number') {
          return first;
        }
        if (typeof first === 'string' && !Number.isNaN(Number(first))) {
          return Number(first);
        }
      }
    }

    return null;
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  logout() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('adminUser');
    sessionStorage.removeItem('authResponse');
    sessionStorage.removeItem('rememberAdmin');
  }

  private parseJwt(token: string): any | null {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    try {
      const payload = parts[1]
        .replace(/-/g, '+')
        .replace(/_/g, '/');
      const decoded = atob(payload);
      const json = decodeURIComponent(
        decoded
          .split('')
          .map((c) => '%'+('00'+c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(json);
    } catch {
      return null;
    }
  }
}
